
import { mapState } from 'vuex'
export default {
  props: {
    blok: {
      type: Object,
      default: () => { }
    },
    heading: {
      type: String,
      default: 'Heads up!'
    },
    description: {
      type: String,
      default: ''
    },
    timeChanged: {
      type: Boolean,
      default: false
    },
    selectedTime: {
      type: String,
      default: ''
    },
    ctaText: {
      type: String,
      default: 'Okay'
    },
  },
  computed: {
    ...mapState(['order', 'channel']),
  },
  mounted() {
    this.$nextTick(() => {
      const errorModal = this.$refs.errorModal

      if (errorModal) {
        errorModal.focus()
      }
    })


  },
  methods: {
    close() {
      this.$emit('close')
    },
  }
}
